import PropTypes from 'prop-types';
export default function AnalyticsPanel({ icon: Icon, title, subtitle, children }) {
    return <section className="analytics-panel" aria-label={title}>
        <header className="analytics-panel-heading"><span className="analytics-panel-icon"><Icon /></span>
        <div><h2>{title}</h2><p>{subtitle}</p></div></header>{children}
    </section>;
}
AnalyticsPanel.propTypes = { icon: PropTypes.elementType.isRequired, title: PropTypes.string.isRequired, subtitle: PropTypes.string, children: PropTypes.node };
